import img1 from "../../assets/images/career/swapnil-nevarekar.png";
import img2 from "../../assets/images/career/geeta.png";
import img3 from "../../assets/images/career/jaswinder.png";
import img4 from "../../assets/images/career/milind.png";
import img5 from "../../assets/images/career/sanket-raut.png";
import img6 from "../../assets/images/career/sharvari-pawar.png";
import img7 from "../../assets/images/career/kanchi-soni.png";
import img8 from "../../assets/images/career/nikhil-bhoyar.png";
import img9 from "../../assets/images/career/ankita-soman.png";

import banImg1 from "../../assets/images/product/choice-drive-big-banner.webp";
import banImg2 from "../../assets/images/product/choice-drive-small-banner.webp";
import banImg3 from "../../assets/images/product/choice-drive-intro.webp";


import Brochureimg1 from "../../assets/images/product/brochure-img.webp"

import BenifitsImg1 from "../../assets/images/product/time-saving.webp"
import BenifitsImg2 from "../../assets/images/product/convenience.webp"
import BenifitsImg3 from "../../assets/images/product/fraud-prevention.webp"
import BenifitsImg4 from "../../assets/images/product/share-quotes.webp"
import BenifitsImg5 from "../../assets/images/product/enhanced-customer-experience.webp"
import BenifitsImg6 from "../../assets/images/product/claims-processing.webp"


import FeaturesImg1 from "../../assets/images/product/product2/pre-integrated.png"
import FeaturesImg1White from "../../assets/images/product/product2/pre-integrated-white.png"

import FeaturesImg2 from "../../assets/images/product/product2/quote-riders.png"
import FeaturesImg2White from "../../assets/images/product/product2/quote-riders-white.png"

import FeaturesImg3 from "../../assets/images/product/product2/kyc-process.png"
import FeaturesImg3White from "../../assets/images/product/product2/kyc-process-white.png"

import FeaturesImg4 from "../../assets/images/product/product2/secure-payment.png"
import FeaturesImg4White from "../../assets/images/product/product2/secure-payment-white.png"

import FeaturesImg5 from "../../assets/images/product/product2/download-policy.png"
import FeaturesImg5White from "../../assets/images/product/product2/download-policy-white.png"

import FeaturesImg6 from "../../assets/images/product/product2/miss-sell.png"
import FeaturesImg6White from "../../assets/images/product/product2/miss-sell-white.png"

import FeaturesImg7 from "../../assets/images/product/product2/auto-calculated.png"
import FeaturesImg7White from "../../assets/images/product/product2/auto-calculated-white.png"

import FeaturesImg8 from "../../assets/images/product/product2/posp.png"
import FeaturesImg8White from "../../assets/images/product/product2/posp-white.png"

const DriveAssureData = {

    "BannerData":[
        {
            "title": "<span>Simplifying</span> Policy Issuance<span>: <br/>Introducing</span> Choice Drive Assure",
            "bannerBigimg" : `${banImg1}`,
            "bannerSmallImg": `${banImg2}`,
            "bannerBtnText": 'Request for a Demo',
            "bannerBtnLink": '/',
            "bannerAlt": '',
            "bannerAltSmall": '',
        },
    ],

    "Introduction":[
        {
            "introContent" :"Choice Drive Assure, is an end to end digital solution for streamlining the process of motor insurance issuance. The platform is designed to make the journey from quote generation to policy download seamless and hassle-free, catering to the needs of both insurance brokers and insurance buyer. With Choice Drive Assure, you can effortlessly generate and compare quotes, complete KYC processes, and download policies within minutes, revolutionizing the way motor insurance is acquired.",
            "introImg": `${banImg3}`,
        }
    ],

    "Features":[
        {
            
            "Img1" : `${FeaturesImg1}`,
            "Img2" : `${FeaturesImg1White}`,
            "FeatHeading": "Pre-integrated insurance kits (10+)",
        },
        {
          
            "Img1" : `${FeaturesImg2}`,
            "Img2" : `${FeaturesImg2White}`,
            "FeatHeading": "Quote & Riders comparison",
        },
        {
            
            "Img1" : `${FeaturesImg3}`,
            "Img2" : `${FeaturesImg3White}`,
            "FeatHeading": "KYC process",
        },
        {
            
            "Img1" : `${FeaturesImg4}`,
            "Img2" : `${FeaturesImg4White}`,
            "FeatHeading": "Secure payment processing",
        },
        {
            
            "Img1" : `${FeaturesImg5}`,
            "Img2" : `${FeaturesImg5White}`,
            "FeatHeading": "Download policy instantly",
        },
        {
            
            "Img1" : `${FeaturesImg6}`,
            "Img2" : `${FeaturesImg6White}`,
            "FeatHeading": "Mis-sell prevention via Greetly",
        },
        {
          
            "Img1" : `${FeaturesImg7}`,
            "Img2" : `${FeaturesImg7White}`,
            "FeatHeading": "Auto calculated commission pay-outs",
        },
        {
           
            "Img1" : `${FeaturesImg8}`,
            "Img2" : `${FeaturesImg8White}`,
            "FeatHeading": "POSP certification module",
        },
    ],



    "Testimonial":[
        {
            "name": "Milind Patil",
            "image":`${img4}`,
            "designation":"Sr.SEO Manager",
            "heading" : "The best place for beginners and new thinkers",
            "para": "I’ve been working with Choice TechLab for the last 7 years. It is the best place for beginners to learn and new thinkers to explore new ideas. As a company, TechLab is focused on staying up-to-date with the latest technology. The TechLab Team is a diverse mix of young and vibrant personalities.",
        },
        {
            "name": "Swapnil Nevarekar",
            "image":`${img1}`,
            "designation":"Engineer - Web Development",
            "heading" : "Every day is a new learning for me",
            "para": "Working at Choice TechLab has been one of my best career decisions. It is a place for people looking for the perfect combination of knowledge and technological boost in the career graph. The processes defined here makes the entire working experience smooth and organized giving one ample space to learn, gain and implement the desired output. With their open work culture and friendly environment, they make sure that you enjoy coming to work every day.",
        },
        {
            "name": "Jaswinder Kaur",
            "image":`${img3}`,
            "designation":"Social Media Manager",
            "heading" : "ChoiceTechLab isn't just a workplace",
            "para": "It's a thriving community where work-life balance is not just encouraged but celebrated. As a team member, I've experienced firsthand the supportive culture that values our well-being as much as our professional growth. At ChoiceTechLab, opportunities abound for learning and advancement, with a culture that fosters creativity and innovation. Whether it's through mentorship programs, or collaborative projects, every day presents a chance to grow personally and professionally.",
        },
        {
            "name": "Geeta Ahuja",
            "image":`${img2}`,
            "designation":"Senior Business Analyst",
            "heading" : "A hub of passionate tech savvy people",
            "para": "Choice TechLab is by far the best place I’ve worked. It’s a hub of passionate tech-savvy people who guide you as well as allow you to grow exponentially in your career. Overall, the work culture is great and the cross training opportunities have really helped me enhance and make optimum use of my skills. The flexible work timing helps me maintain work life balance.",
        },
        {
            "name": "Sanket Raut",
            "image":`${img5}`,
            "designation":"Associate Software Engineer",
            "heading" : "Being a part of this IT company has truly been a game-changer for me",
            "para": "Receiving the innovation award was not just a personal achievement but a testament to the incredible opportunities this company provides. With its AI-driven approach and a constant focus on cutting-edge technologies, this company has created an environment where innovation thrives. I'm grateful to be part of a team that not only embraces the latest advancements but actively encourages and supports them. This is more than just a workplace; it's a place where dreams are nurtured and possibilities are endless.",
        },
        {
            "name": "Sharwari Pawar",
            "image":`${img6}`,
            "designation":"QA",
            "heading" : "Indeed its a pleasure working here",
            "para": 'What makes us keep going in Choice is our keen eye for detail and unwavering commitment to precision have become synonymous with the products/services we deliver, earning us the trust and loyalty of our customers. Also as mentioned in our logo "Choice  The joy of Earning" Indeed its a pleasure working here , instilling confidence in our brand and reinforcing our position as a trusted provider in the industry.',
        },
        {
            "name": "Kanchi Soni",
            "image":`${img7}`,
            "designation":"UI UX Executive",
            "heading" : "Their team fosters an environment where creativity thrives",
            "para": "As a UI/UX Designer, working with Choice Techlab Designs understands the importance of collaboration and communication in the design process. From the initial concept discussions to the final product delivery, their team fosters an environment where creativity thrives. They value my input as a designer and empower me to bring my ideas to life, resulting in beautifully crafted digital experiences.",
        },
        {
            "name": "Nikhil Bhoyar",
            "image":`${img8}`,
            "designation":"Product Manager",
            "heading" : "The work environment is excellent",
            "para": "At Choice Techlab, the work environment is excellent, nurturing both professional and personal development. Management values each team member, promotes diverse viewpoints, and offers robust support. As a Product Manager, I appreciate the opportunity to make product decisions, knowing my reporting manager stands ready to support in any challenging situation, fostering motivation and growth.",
        },
        {
            "name": "Ankita Soman",
            "image":`${img9}`,
            "designation":"Senior Software Engineer",
            "heading" : " It is a dynamic ecosystem where innovation, collaboration, and personal growth thrive.",
            "para": "I have had the privilege of working as a Senior Software Engineer at ChoiceTechLab Pvt Ltd, and I can confidently say that it has been an enriching and fulfilling experience. ChoiceTechLab is not just a company; it’s a dynamic ecosystem where innovation, collaboration, and personal growth thrive.",
        },

    ],

    "ProductBenifits": [
        {
            "BenifitsHeading": "Time-saving",
            "BenifitsImg": `${BenifitsImg1}`,
        },
        {
            "BenifitsHeading": "Convenience",
            "BenifitsImg": `${BenifitsImg2}`,
        },
        {
            "BenifitsHeading": "Fraud prevention",
            "BenifitsImg": `${BenifitsImg3}`,
        },
        {
            "BenifitsHeading": "Share quotes/proposal via WhatsApp/Email",
            "BenifitsImg": `${BenifitsImg4}`,
        },
        {
            "BenifitsHeading": "Enhanced customer experience",
            "BenifitsImg": `${BenifitsImg5}`,
        },
        {
            "BenifitsHeading": "Streamlined claims processing",
            "BenifitsImg": `${BenifitsImg6}`,
        },
        
    ],

    "Brochure":[
        {
            "BrochureImg": `${Brochureimg1}`,
            "BrochureLink": "/",
        }
    ],

    "FooterCtaSection":[
        {
            // "CtaHeading": "Join the Innovation",
            "CtaDescriptiom":"Experience the power of Choice Drive Assure and revolutionize the way you acquire motor insurance. Whether you're an insurance provider looking to streamline policy issuance or a policyholder in need of quick and convenient insurance solutions, Choice Drive Assure has you covered. Request a demo today and discover how Choice Drive Assure can simplify the motor insurance process for you.",
            "CtaBtnText": 'Request for a Demo',
            "CtaBtnLink": '/',
            "CtaBtnTarget": '',
        },
    ],

    
} 

export default DriveAssureData;